import type {
  TaskResponse,
} from './shared';

export type ChangeAssigneeRequest = {
  assignee?: string;
  candidateUsers?: string[];
  candidateGroups?: string[];
}

export type CompleteTaskResponse = {
  responseType?: ResponseType;
  taskId?: string;
  formOutcome?: string;
  formId?: string;
  messages?: string[];
}

export type PagedResponseTaskResponse = {
  data?: TaskResponse[];
  total?: number;
  start?: number;
  sort?: string;
  order?: string;
  size?: number;
}

export enum ResponseType {
  TASK_NOT_FOUND = 'TASK_NOT_FOUND',
  FORM_OUTCOME_NOT_FOUND = 'FORM_OUTCOME_NOT_FOUND',
  SUCCESS = 'SUCCESS',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export type TaskAction = {
  action?: string;
  taskId?: string;
  outcome?: string;
  variables?: Record<string, unknown>;
  complete?: boolean;
}

export type TaskCompletionRequest = {
  taskIds?: string[];
  action?: TaskAction;
}
